<form [formGroup]="form">
    <app-picklist [formControl]="form.controls.selectedSecondaryEquipments"
                  [source]="availableSecondaryEquipments"
                  [target]="selectedSecondaryEquipments"
                  displayField="nameWithLine"
                  sourceHeader="{{'admin.tools.create-modal.pick-list.equipment.leftHeader' | translate}}"
                  targetHeader="{{'admin.tools.create-modal.pick-list.equipment.rightHeader' | translate}}">
    </app-picklist>
</form>
